import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './global.css';
import App from './App';
import useAppState from './domain/store';

const AppInitializer: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const setReferrer = useAppState((state) => state.setReferrer);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const referrer = params.get('referrer');
    if (referrer) {
      setReferrer(referrer);
    }
  }, [setReferrer]);

  return <>{children}</>;
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AppInitializer>
      <App />
    </AppInitializer>
  </React.StrictMode>
);
